import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { OrganisationMemberRequestDto, OrganisationMemberResponseDto, OrganisationMemberService } from 'src/app/backend';
import {
  ApiUsersPutRequestParams,
  UsersService,
} from '../../../backend/api/users.service';
import { UserRoleEnum } from '../../../backend/model/userRoleEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { SexEnum } from '../../../backend/model/sexEnum';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  templateUrl: './save-org-member-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})
export class OrgMemberDialogComponent extends BaseComponent {
  UserRole = UserRoleEnum;
  form = new UntypedFormGroup({});
  id = 0;
  SexEnum = SexEnum;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private orgMember: OrganisationMemberService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      dateOfBirth: new UntypedFormControl(),
      note: new UntypedFormControl(),
      sex: new UntypedFormControl(),
      joined: new UntypedFormControl(),
      email: new UntypedFormControl(),
      phone: new UntypedFormControl(),
      id: new UntypedFormControl(),
    });

    if (this.id) {
      this.loadUser(this.id);
    }
  }


  disabledEndDate = (endValue: Date): boolean => {
    if (endValue.getDate() < new Date().getDate()) {
      return false;
    }

    return true;
  }

  loadUser(id: number) {
    this.isLoading = true;
    this.orgMember.apiOrganisationmemberIdGet({ id }).subscribe(
      (res) => {
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          dateOfBirth: res.dateOfBirth,
          note: res.note,
          sex: res.sex,
          joined: res.joined,
          email: res.email,
          phone: res.phone,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: OrganisationMemberRequestDto = {
      name: this.form.value.name,
      dateOfBirth: this.form.value.dateOfBirth,
      note: this.form.value.note,
      sex: this.form.value.sex || null,
      joined: this.form.value.joined,
      email: this.form.value.email,
      phone: this.form.value.phone,
      id: this.form.value.id
    };

    console.log(data);

    const apiCall = this.id
      ? this.orgMember.apiOrganisationmemberPut({
          organisationMemberRequestDto: data,
        })
      : this.orgMember.apiOrganisationmemberPost({organisationMemberRequestDto: data});

    this.isSaving = true;

    apiCall.subscribe(
      (res) => {
        this.isSaving = false;
        this.close(true);
      },
      (err) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }
}
